import axios from 'axios'

const openWeatherApiKey = process.env.REACT_APP_OPEN_WEATHER_API_KEY || ''

export function getWeather(location) {
  return {
    type: 'GET_WEATHER',
    meta: {
      offline: {
        effect: () => {
          const instance = axios.create()
          instance.defaults.headers.common = {}
          return instance
            .get('https://api.openweathermap.org/data/2.5/weather', {
              params: {
                ...location,
                APPID: openWeatherApiKey,
                units: 'metric',
              },
            })
            .then(response => {
              return {
                weatherId: response.data.weather[0].id,
                description: response.data.weather[0].description,
                name: response.data.name,
                temperature: parseInt(response.data.main.temp, 0),
              }
            })
        },
        commit: {
          type: 'GET_WEATHER_COMMIT',
        },
      },
    },
  }
}

export function setWeatherDescription(description) {
  return {
    type: 'SET_WEATHER',
    payload: { description },
  }
}
